import { useCallback } from 'react';
import { CallLogRow } from '../components/calls/call_log_columns';
import { joinPaths } from '../util/routing';
import { useHistory } from 'react-router-dom';

export const useCallLogPage = () => {
    const history = useHistory();

    const rowClickUrl = useCallback(
        (row: CallLogRow) => {
            const url = joinPaths(history.location.pathname, row.roomSid);
            history.push(url);
        },
        [history],
    );

    const isRowClickable = useCallback(
        (row: CallLogRow) => row.roomSid && row.callStatus === 'STATUS_SUCCESSFUL',
        [],
    );

    return {
        rowClickUrl,
        isRowClickable,
    };
};
